import { RoaValues, RoaResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Simplified ROA (pre-tax version): (Operating income + Interest expense) / (Equity + Debt) * 100
export function calculateRoa(values: RoaValues, t?: ToolsTranslations['roa']): RoaResult {
  const { operatingIncome, interestExpense, equity, totalDebt } = values;

  if (operatingIncome < 0) return { percent: null, isValid: false, message: t?.invalid.operatingIncome };
  if (interestExpense < 0) return { percent: null, isValid: false, message: t?.invalid.interestExpense };
  if (equity < 0) return { percent: null, isValid: false, message: t?.invalid.equity };
  if (totalDebt < 0) return { percent: null, isValid: false, message: t?.invalid.totalDebt };

  const totalAssetsApprox = equity + totalDebt;
  if (totalAssetsApprox <= 0) return { percent: null, isValid: false, message: t?.invalid.generic };

  const numerator = operatingIncome + interestExpense; // add back interest to approximate EBIT
  const percent = Math.round(((numerator / totalAssetsApprox) * 100) * 100) / 100; // 2 decimals
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };

  return { percent, isValid: true };
}


